// ----------------------------------------------------------------------
// <copyright file="Izenda.GridPaginatorAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var compose = require('recompose').compose;
  var mapProps = require('recompose').mapProps;
  var observer = require('mobx-react').observer;
  var classnames = require('classnames');
  var reportDesignerConstants = require('logic/data/Izenda.ReportDesignerConstants');
  const { omit, isEmpty, assign, isNil, get } = require('lodash/fp');
  var action = compose(
    observer,
    mapProps(function(props) {
      var restProps = omit(['reportPart'], props);
      var reportPart = props.reportPart;
      var usePagination = get('reportPartContent.properties.view.usePagination', reportPart);
      var records = reportPart.previewDataRecords;
      var isBeingBuild = reportPart.isBeingBuild;
      var hide = !isBeingBuild || !usePagination || isEmpty(records);
      var paging = reportPart.previewData.paging || {
        total: 0,
        pageSize: reportDesignerConstants.DEFAULT_PAGE_SIZE,
        pageIndex: reportDesignerConstants.DEFAULT_PAGE_INDEX
      };

      return assign(restProps, {
        totalRecords: paging.total || 0,
        pageSize: !isNil(paging.pageSize) ? paging.pageSize : reportDesignerConstants.DEFAULT_PAGE_SIZE,
        pageIndex: !isNil(paging.pageIndex) ? paging.pageIndex : reportDesignerConstants.DEFAULT_PAGE_INDEX,
        className: classnames('with-border', { hide: hide })
      });
    })
  );

  module.exports = action;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGrid/Izenda.GridPaginatorAction.js